export const randomId = () =>
  globalThis.crypto?.randomUUID?.() ?? `id-${Date.now()}-${Math.random().toString(16).slice(2)}`;

export const createId = (prefix) => `${prefix}-${randomId()}`;

export const cloneDeep = (value) => JSON.parse(JSON.stringify(value));

export const regenerateLayoutIds = (layout) => {
  const next = cloneDeep(layout);
  next.id = createId("layout");
  next.grids = (next.grids || []).map(regenerateGridIds);
  return next;
};

export const regenerateGridIds = (grid) => {
  const next = cloneDeep(grid);
  next.id = createId("grid");
  if (!next.name) {
    next.name = "Layout";
  }
  next.rows = (next.rows || []).map((row) => {
    const nextRow = { ...row, id: createId("row") };
    nextRow.columns = (row.columns || []).map((column) => {
      const nextColumn = {
        ...column,
        id: createId("col"),
        props: cloneDeep(column.props || {}),
        children: (column.children || []).map((child) => {
          if (child.type === "grid") {
            return regenerateGridIds(child);
          }
          if (child.type === "component") {
            return {
              ...child,
              id: createId("cmp"),
              props: cloneDeep(child.props || {}),
            };
          }
          return child;
        }),
      };
      return nextColumn;
    });
    return nextRow;
  });
  return next;
};
 